import { string } from 'yup'

const cssDimensionValueRegex =
  /^(?:\d+(?:\.\d+)?(?:px|em|rem|%|in|cm|mm|pt|pc|vh|vw)?|auto|inherit)$/i

export const cssDimensionSchema = string().matches(cssDimensionValueRegex)
